// extracted by mini-css-extract-plugin
export var root = "SidebarLayout-module--root--McAXx";
export var menuButton = "SidebarLayout-module--menuButton--1pKtC";